import type { HighlightReview } from '@/types/models'
import { locationListIsInternational } from '../location/useCases/computeLocationGroups'
import { isNil } from '@/utils/checks'

export const filterReviewsByGlobalTerm = ({
  reviews,
  isGlobalTerm
}: {
  reviews: HighlightReview[]
  isGlobalTerm: boolean
}): HighlightReview[] => {
  if (isGlobalTerm) {
    const internationReviews = reviews.filter((review: HighlightReview) =>
      locationListIsInternational(review._center.locations)
    )
    const unitedStateReviews = reviews.filter(
      (review: HighlightReview) =>
        !locationListIsInternational(review._center.locations)
    )
    return [...internationReviews, ...unitedStateReviews]
      .filter((review: HighlightReview) => !isNil(review._center.budget_pacing))
      .sort(
        (a: HighlightReview, b: HighlightReview) =>
          (a._center.budget_pacing ?? 10001) -
          (b._center.budget_pacing ?? 10001)
      )
  }
  return reviews.filter(
    (review: HighlightReview) =>
      !locationListIsInternational(review._center.locations)
  )
}
